import * as z from "zod";
import { assertIdpSyncNotActive } from "../rbac/validation";
import { mutator } from "./mutator";

export const reactivateUserSchema = z.object({
  userId: z.string(),
});

export const reactivateUser = mutator({
  schema: reactivateUserSchema,
  resolve: {
    target: { kind: "user", from: "userId" },
  },
  permissions: [
    { permission: "tenant:users_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { target } }) => {
    await assertIdpSyncNotActive(tx, ctx.tenantId, "userActivation");

    await tx.mutate.user.update({
      id: target.id,
      deactivated: false,
      emailVerified: true,
    });
  },
});
